import { CATEGORY_TYPES } from 'constants/restrictions'

export const getCategoryName = (categoryId, content) => {
  const category = CATEGORY_TYPES[categoryId]
  return content[`restriction_products_category_${category}`]
}
